import React from 'react'
import { UserOutlined } from '@ant-design/icons';
import { LockOutlined } from '@ant-design/icons';
//import axios from 'axios';
import axios from './axios_cg';
import { Modal, Button, Form, Input, Row, Col, message} from 'antd';
import $ from 'jquery'
import './home.less';
import Qs from 'qs';
import img_logo from './static/new_img/logo.png';
import new_layer_img from './static/new_img/layer.jpg';
import md5 from 'js-md5';
import { validatePhone, validateEmail } from './validate';


class HomeHead extends React.Component {
    captchaIns = null

    constructor(props) {
        super(props);
        this.state = {
            register_modal: false,
            register_result_modal:false,
            register_result_msg:'',
            register_result_msg_color:'#000000',
            login_modal:false,
            login_result_modal:false,
            login_result_msg:'',
            login_result_msg_color:'#000000',
            base_cg_client_url:'',//稳定版本url
            base_cg_version_nunber:'',
            newest_cg_client_url:'',
            newest_cg_version_nunber:'',
            newest_show:'',
            isDisabled:true,
            isDisabled_no:true,//改为默认不可用 只有注册手机号输入后才可以
            wangyi_pic_code:'',
            mobile_code_send_modal: false,
            password_modal_init:false,
            password_modal_end:false,
            password_isDisabled:true,//默认置灰
            password_isDisabled_no:false,
            password_wangyi_pic_code:'',
            password_result_msg:'',
            password_result_modal:false,
            password_email:"none",
            password_emailcode:"none",
            password_mobile:"",
            password_mobilecode:"",
            password_oldpassword:"",
            password_email_isDisabled:true,//邮箱验证码 按钮等是否显示 这个暂时不写.现在只提供 手机/旧密码修改2种方式  2020.6.5 修改特别说明!
            //6 张图片 合1块 切换大小图片
            hover_p:false,// https://blog.csdn.net/fay462298322/article/details/76998324/
            display_code:"none",//注册默认 不显示
            password_type:'mobile',//重置密码选择的类型  默认邮箱(标志字段)
            email_par_display:'',      //重置密码 第1个modal  选择 邮箱重置时 显示的字段
            email_par2_display:'none',
            mobile_par_display:'none', //重置密码 第1个modal  选择 手机重置时 显示的字段
            mobile_par2_display:'none',
            pwd_modal_style: 'web_password_modal',
            checkUnique_result:'',// 记录 check 结果
            password_email_code_modal:false,
            wyy_v1_code:'',//网易云 v1.0 的码 改密码用的
            wyy_v1_code_register:'',//网易云 v1.0 的码 注册用的
            register_mobile_code_modal:false,//注册输入 手机验证码的 modal
            register_mobile:'',
            pic_data:'',
            pwd_email:'',
            login_but_display:'',
            register_but_display:'',//网页头部注册按钮 显示 开关
            login_account_display:'none',
            login_account:'',//登录用户名
            login_account_id:'',
            logout_but_display:'none',
            login_pwd_msg:'str',//非空的 str
            register_fail_msg:'str',//非空的 str
            login_pwd_msg_opacity:0,//通过设置同名度 因为空str 哪怕设置了 隐藏占位 也没元素内容
            register_fail_msg_opacity:0,//
            djang_api_url: '/api',
            // 同时支持 cg/xneo新 接口
            new_api:'',
            xneo_api_url: '/infra-account-center',
            wyy_reqId:'',
            register_but_to_wyy_display:'',//注册页面 用来点击跳出wyy的 but
            pwd_but_to_wyy_display:'none',//pwd页面 用来点击跳出wyy的 but 默认不显示
            register_send_mobilecode_but_msg:'获取验证码',
            pwd_send_mobilecode_but_msg:'获取验证码',
            pwd_email_form_display:'',
            pwd_email_required:true,
            pwd_mobile_form_display:'none',
            pwd_mobile_required:false,
            base_url:'',
        };
    }


    componentWillMount () {
        this.use_which_api()

        //来控制 导航栏 里的显示(登录|没有登录2种情况)
        this.init_is_login('init');

        window.inputValue = function (dom, st) {
            var evt = new InputEvent('input', {
                inputType: 'insertText',
                data: st,
                dataTransfer: null,
                isComposing: false
            });
            dom.value = st;
            dom.dispatchEvent(evt);
        }

    }

    // 组件加载完毕 启动定时器
    componentDidMount(){
        setTimeout(this.iTimerOnline,0);//暂时不加,后面和客户端版本一起加
    }

    //定时器
    iTimerOnline = () => {
        this.timer = setInterval(() => {
            axios.get('/api/account_login_keepline/') //特别说明:不需要判断用户是否在线,接口里面会自己判断
        }, 600000);//现在设定为 10分钟中刷新1次
    }

    use_which_api = () => {
        this.setState({
            new_api: process.env.REACT_APP_USE_API
        })
    }

    init_is_login = (action_msg) =>{
        //来判断下用户?登录
        const url = this.state.djang_api_url + "/get_login_msg/";
        axios.get(url)
        .then(response => {
            if (response.data.loginName !== "" && response.data.loginName !== null){
                //已登录
                this.setState({
                login_but_display:'none',
                register_but_display:'none',
                login_account_display:'',
                logout_but_display:'',
                login_account:response.data.loginName
                },()=>{
                    if (action_msg !== "init"){
                        message.info('用户已登录.');
                    }
                })
            }else{
                //没有登录
                this.setState({
                login_but_display:'',
                register_but_display:'',
                login_account_display:'none',
                logout_but_display:'none',
                login_account:""
                },()=>{
                    if (action_msg !== "init"){
                        this.showLoginModal();
                    }
                })
            }
        });
    }

    //注册 手机号 input的监测
    enable_but_wyy = () =>{
        //现在修改规则
        //手机号只影响 请点击验证安全码(isDisabled_no) 是否显示 ，
        if ($('#horizontal_register_mobile').val().length === 11){
            this.setState({
                isDisabled_no:false
            });
        }else{
            this.setState({
                isDisabled_no:true
            });
        }
    }

    //登录_密码_字段监测
    input_login_pwd = () =>{
         this.setState({
                 login_pwd_msg: 'str',
                 login_pwd_msg_opacity: 0
             }
         )
    }


    //重置密码 手机号 input的监测
    password_enable_but_mobile = () =>{

    }

    //注册
    // 特别说明:因为新的登录 只支持 网易v2的验证,所以需要把 之前cg的也改为v1版本,否则 同时引入 2个js 会有问题
    // 1.CG (网易v1版)
    wyy_v1_add_register = () =>{
         this.setState({
             register_but_to_wyy_display:'none',
             register_fail_msg_opacity:0,
             register_fail_msg:'str'
         });
         $('#captcha_reg').css('display','');
         $('#captcha_reg').children().remove();
         $('#captcha_reg').css('height','65px');
        var opts = {
            "element": "captcha_reg",
            "captchaId": "bb486567c8974cbaa8447d7573a832cf", // CG 该captchaId(bb486567c8974cbaa8447d7573a832cf)对应使用v1版本的js
            "width": 320,
            "verifyCallback": (ret) =>{
                if(ret['value']){
                    if ('validate' in ret){
                        $('#captcha_reg').css('display','none');
                        this.setState({
                            'wyy_v1_code_register':ret['validate'],
                            'isDisabled':false //网易 成功后 获取 验证码 按钮可用
                        },
                        )
                    }
                }
            }
        }
       new window.NECaptcha(opts);
    }

    cg_wyy_v2_add_register = () =>{
        this.setState({
            register_but_to_wyy_display:'none',
            register_fail_msg_opacity:0,
            register_fail_msg:'str'
        });
        $('#captcha_reg').css('display','');
        $('#captcha_reg').children().remove();
        $('#captcha_reg').css('height','65px');

        const that = this

        window.initNECaptcha({
            captchaId: 'bb486567c8974cbaa8447d7573a832cf', //
            element: '#captcha_reg',
            mode: 'float',
            width: '320px',
            onVerify(err, d) {
                // 已经滑动
                if (err) {
                    // 滑动错误
                    return
                }
                // 滑动验证正确
                $('#captcha_reg').css('display','none');
                that.setState({
                    'wyy_v1_code_register':d.validate,
                    'isDisabled':false //网易 成功后 获取 验证码 按钮可用
                })
            }
        }, function onload (instance) {
            that.captchaIns = instance
        }, function onerror (err) {
            // 初始化失败处理逻辑，例如：提示用户点击按钮重新初始化
            console.log(err)
        })
    }
    // 2.xneo(网易v2版本)
    xneo_wyy_v2_add_register = () =>{
        this.setState({
            register_but_to_wyy_display:'none',
            register_fail_msg_opacity:0,
            register_fail_msg:'str'
        });
        $('#captcha_reg').css('display','');
        $('#captcha_reg').children().remove();
        $('#captcha_reg').css('height','65px');

        const that = this

        window.initNECaptcha({
            captchaId: '21e22225952443eca52123a3d19f299b', // xneo 这个 captchaId 需要用 网易2.0版本 http://cstaticdun.126.net/load.min.js?t=201903281201
            element: '#captcha_reg',
            mode: 'float',
            width: '320px',
            onVerify(err, d) {
                // 已经滑动
                if (err) {
                    // 滑动错误
                    return
                }
                // 滑动验证正确
                $('#captcha_reg').css('display','none');
                that.setState({
                    'wyy_v1_code_register':d.validate,
                    'isDisabled':false //网易 成功后 获取 验证码 按钮可用
                })
            }
        }, function onload (instance) {
            that.captchaIns = instance
        }, function onerror (err) {
            // 初始化失败处理逻辑，例如：提示用户点击按钮重新初始化
            console.log(err)
        })
    }


    //改密码(网易v1版的图片验证)
    wyy_v1_add_pwd = () =>{
        $('#captcha_pwd').css('display','');
        $('#captcha_pwd').children().remove();
        var opts = {
            "element": "captcha_pwd",
            "captchaId": "bb486567c8974cbaa8447d7573a832cf",
            "width": 320,
            "verifyCallback": (ret) =>{
                if(ret['value']){
                    if ('validate' in ret){
                        $('#captcha_pwd').css('display','none');
                        this.setState({
                            'wyy_v1_code':ret['validate'],
                        },()=>{
                            if ($('#horizontal_password_mobile').val().length === 11 && this.state.wyy_v1_code.length > 0 && this.state.wyy_v1_code !== undefined){
                                this.setState({
                                    password_isDisabled:false,
                                    password_isDisabled_no:true
                                });
                            }else{
                                this.setState({
                                    password_isDisabled:true,
                                    password_isDisabled_no:false
                                });
                            }
                        })
                    }
                }
            }
        }
       new window.NECaptcha(opts);
    }


    //注册初始化
    showRegisterModal = () =>{
        this.setState({
            login_modal:false,
            password_modal_init:false,
            register_modal:true,//打开注册 modal
            isDisabled_no:true,//默认置灰
            isDisabled:true,
            register_send_mobilecode_but_msg:'获取验证码',
            register_but_to_wyy_display:'',
            register_fail_msg_opacity:0,
            register_fail_msg:'str'
        });
    }

    //登录初始化
    showLoginModal = () =>{
        this.setState({
            login_modal:true,
            password_modal_init:false,
            register_modal:false,
            login_pwd_msg:'str',
            login_pwd_msg_opacity:0
        });
    }

    email_password_hover = () =>{
         this.setState({
             pwd_email_form_display:'',
             pwd_mobile_form_display:'none',
             pwd_email_required:true,
             pwd_mobile_required:false,
         });
        $('#by_email_password').css('color','#149eed');
        $('#by_mobile_password').css('color','#585858');
        $('#horizontal_password').css('top','145px');
        this.setState({
            password_type:'email',
            email_par_display:'',
            mobile_par_display:'none',
            pwd_modal_style:'web_password_modal',
            pwd_but_to_wyy_display:'none',
        });
    }

    mobile_password_hover = () =>{
        this.setState({
             pwd_mobile_form_display:'',
             pwd_email_form_display:'none',
             pwd_mobile_required:true,
             pwd_email_required:false
         });
        $('#by_mobile_password').css('color','#149eed');
        $('#by_email_password').css('color','#585858');
        $('#horizontal_password').css('top','145px');
        //所有关于邮箱的内容全部 不显示
        this.setState({
            password_type:'mobile',
            email_par_display:'none',
            mobile_par_display:'',
            pwd_modal_style:'web_password_modal_big',
            pwd_but_to_wyy_display:'',
        });
    }

    //重置密码初始化
    showPasswordModal = () =>{
        this.setState({
            password_modal_init:true,
            login_modal:false,
            register_modal:false
        });
        this.email_password_hover();
        const url = this.state.djang_api_url + "/python_validateImage/";
        axios.get(url,
            {
                responseType: 'arraybuffer',
                withCredentials: true//携带cookie
            }
        ).then( (response)=> {
            const pic_datas ='data:image/png;base64,' + btoa(
                new Uint8Array(response.data).reduce((data, byte) => data + String.fromCharCode(byte), '') //base64编码转图片
            );
            this.setState({
                pic_data:pic_datas
            },()=>{
                $('#xy_img').attr('src',pic_datas);
            })

            return pic_datas
        }).then(
            data =>{
                this.qrcode =data
            }
        )
    }


    //注册  获取手机短信验证码
    // 1.CG
    post_get_mobilecode = () => {
        this.setState({
             isDisabled:true
         })
        const url = this.state.djang_api_url + "/account_register_mobile_code/";
        const data = {
            'phone': $('#horizontal_register_mobile').val(),
            'code':this.state.wyy_v1_code_register,
        };
        axios.post(url, Qs.stringify(data),
            {
                headers:{'Content-Type':'application/x-www-form-urlencoded'}
            }
        );
    }
    // 2.xneo
    xneo_post_get_mobilecode = () => {
        this.setState({
             isDisabled:true
         })
        const url = this.state.xneo_api_url + "/verification-code";
        const data = {
            'key': $('#horizontal_register_mobile').val(), // 手机号
            'type': 1, // 验证方式 1：手机
            'validate':this.state.wyy_v1_code_register // 易盾验证码
        };
        axios.post(url, data,
            {
                headers:{
                    'appname': 'web',
                    'productType': 3
                }
            }
        ).then( (response)=> {
            if (response.data.data.code === 1){
                this.setState({
                     wyy_reqId: response.data.data.data.reqId
                })
            }
        }).catch( (error) =>{
            console.log(error)
        })
    }

    //手机 重置密码 (获取手机验证码)
    setpwd_post_get_mobilecode = () => {
        const url = this.state.djang_api_url + "/pwd_mobile_code/";
        const data = {
            "phone": $('#horizontal_password_mobile').val(),
            "code": this.state.wyy_v1_code,
        };
        axios.post(url, Qs.stringify(data),
            {headers:{'Content-Type':'application/x-www-form-urlencoded'}}
        );
    }

    //重置密码 发送邮箱 code
    pwd_email_code_send = () => {
        const url = this.state.djang_api_url + "/pwd_email_code/";
        const data = {
            "validateNum": $('#horizontal_password_pic_code').val(),
            "regEmail": $('#horizontal_password_email').val(),
        };
        axios.post(url, Qs.stringify(data),
            {
                headers:{'Content-Type':'application/x-www-form-urlencoded'}
            }
        );
    }

    change_modal = (message) =>{
        this.setState({
            register_result_msg: message,
            register_result_modal:true,
            register_modal:false,
        });
    }

    change_modal_login = (message) =>{
        this.setState({
            login_result_msg: message,
            login_result_modal:true,
            login_modal:false,
        });
    }

    change_modal_password = (message) =>{
        this.setState({
            password_result_msg: message,
            password_result_modal:true,
            password_modal_init:false,
            password_modal_end:false,
            password_email_code_modal:false
        });
    }

    // 注册
    // 1.CG
    onFinishRegister = values => {
        const url = this.state.djang_api_url + "/account_register/";
        const data = {
            "nickName": $('#horizontal_register_username').val(),
            "phone": $('#horizontal_register_mobile').val(),
            "password": $('#horizontal_register_password').val(),
            "serviceType": 1,
            "serviceItem":'on',
            "phone1": $('#horizontal_register_mobile').val(),
            "dynCode": values.mobilecode,
            "NECaptchaValidate": this.state.wyy_v1_code_register,
        };
        axios.post(url, Qs.stringify(data),
            {headers:{'Content-Type':'application/x-www-form-urlencoded'}}
        ).then( (response)=> {
            if (response.data ==="ok"){
                this.change_modal('用户注册成功');
            }else{
                //手机验证码错误
                //this.change_modal('用户注册失败');
                 if  (response.data === "手机验证码错误") {
                     this.setState({
                         register_fail_msg: '* 手机验证码错误,请重新点击验证安全码继续注册.',
                         register_fail_msg_opacity: 1,
                         isDisabled_no:false,//重新可以 点击验证安全码,重新获取验证码
                         register_but_to_wyy_display:''
                         }
                     )
                 }
            }
        }).catch( (error) =>{
            this.change_modal('用户注册失败');
        })

        //关掉
        this.setState({
            register_mobile_code_modal:false
        });
    };
    // 2.xneo
    xneo_onFinishRegister = values => {
        const url = this.state.xneo_api_url + "/user/register";
        const data = {
            "nickname": $('#horizontal_register_username').val(),
            "key": $('#horizontal_register_mobile').val(), // 手机号
            "password": md5($('#horizontal_register_password').val()),
            "reqId": this.state.wyy_reqId, // 请求id
            "type": 1, // 注册方式 1：手机
            "verificationCode": values.mobilecode // 验证码
        };
        axios.post(url, data,
            {headers:{
                'appname': 'web',
                'productType': 3
            }}
        ).then( (response)=> {
            if (response.data.data.code === 1){
                this.change_modal('用户注册成功');
            }else{
                //手机验证码错误
                 if  (response.data.data.code === 201) {
                     this.setState({
                         register_fail_msg: '* 手机验证码错误,请重新点击验证安全码继续注册.',
                         register_fail_msg_opacity: 1,
                         isDisabled_no:false,//重新可以 点击验证安全码,重新获取验证码
                         register_but_to_wyy_display:''
                         }
                     )
                 }
            }
        }).catch( (error) =>{
            this.change_modal('用户注册失败');
        })

        //关掉
        this.setState({
            register_mobile_code_modal:false
        });
    };

    // (调用)登录接口
    // 1.cg
    onFinishLogin = values => {
        const url = this.state.djang_api_url + "/account_login/";
        const data = {
            'name':values.username,
            'password':values.password
        };
        this.login_function(url,data);
    };
    // 2.xneo
    xneo_onFinishLogin = values => {
        const url = this.state.xneo_api_url + "/oauth/authorize";
        const data = {
            'authorizeKey': values.username,
            'password': md5(values.password),
            'clientId': '0073b5b3f9b8457c8c0981300ae79595'
        };
        if (validatePhone(values.username)) {
            data.authorizeType = 1
        } else if (validateEmail(values.username)) {
            data.authorizeType = 2
        } else {
            data.authorizeType = 3
        }
        this.xneo_login_function(url,data);
    };

    login_function = (url,data) =>{
        axios.post(url, data
        ).then( (response)=> {
             if (response.data.message === "用户登录成功"){
                 this.setState({
                    login_but_display:'none',
                    register_but_display:'none',
                    login_account_display:'',
                    logout_but_display:'',
                    login_account:response.data.loginName,
                    login_account_id:response.data.id
                 },()=>{
                     this.change_modal_login(response.data.message);
                     this.init_is_login('init');//刷新 子组件自己
                 })
             }
        }).catch( (error) =>{
            //登录失败
             if  (error.message === "Request failed with status code 400") {
                 this.setState({
                     login_pwd_msg: '* 账号或密码不正确(注意区分大小写)，请重新输入',//因为现在还在支持新架构的登录,so 没办法判断具体 是 账户还是密码 错误
                     login_pwd_msg_opacity: 1
                 })
             }else{
                 this.setState({
                     login_pwd_msg: '* 其他错误',
                     login_pwd_msg_opacity: 1
                })
             }
        })
    }

    xneo_login_function = (url,data) =>{
        axios.post(url, data,
            {headers:{
                'appname': 'web',
                'productType': 3
            }}
        ).then( (response)=> {
             // 登录成功
            if (response.data.data.code === 1) {
                 // 登录成功后去获取用户信息
                const url_msg = this.state.xneo_api_url + "/oauth/information/code/special?code="+response.data.data.data.code+"&clientSecret=5a33ca77d6524c9c9fcae208fc24cc2b"+'&clientId=0073b5b3f9b8457c8c0981300ae79595'
                const data_msg = {
                    'code': response.data.data.data.code,
                    'clientSecret': '5a33ca77d6524c9c9fcae208fc24cc2b',
                    'clientId': '0073b5b3f9b8457c8c0981300ae79595'
                };

                axios.get(url_msg,
                    {headers:{
                        'appname': 'web',
                        'productType': 3
                    }}
                ).then( (res)=> {
                    if (res.data.data.code === 1) {
                        this.setState({
                            login_but_display: 'none',
                            register_but_display: 'none',
                            login_account_display: '',
                            logout_but_display: '',
                            login_account: res.data.data.data.nickname,
                            login_account_id: res.data.data.data.id
                        }, () => {
                             this.change_modal_login("用户登录成功");
                        })
                    }
                }).catch( (error) =>{
                    console.log('获取授权失败,', error)
                })
            } else if(response.data.data.code === 103) {
                 this.setState({
                     login_pwd_msg: '* 账号或密码不正确(注意区分大小写)，请重新输入',
                     login_pwd_msg_opacity: 1
                 })
            } else {
                 this.setState({
                     login_pwd_msg: '* 其他错误',
                     login_pwd_msg_opacity: 1
                })
            }
        }).catch( (error) =>{
            this.setState({
                login_pwd_msg: '* 其他错误',
                login_pwd_msg_opacity: 1
            })
        })
    }

    //logout
    onFinishLogout = () => {
        const url = this.state.djang_api_url + "/account_logout/";
        axios.get(url
        ).then( (response)=> {
             this.setState({
                login_but_display:'',
                register_but_display:'',
                login_account_display:'none',
                login_account:'',
                logout_but_display:'none',
                login_account_id:''
             }, ()=>{
                //现在是用户登录和登出都会通知给父组件
                this.props.sou_msg_to_father({'action':'登录','login_id':''});
             })
        })
    };


    //action pwd
    onFinishPasswordSet = values => {
        //手机+网易云===>手机动态码 pwd
        const url = this.state.djang_api_url +"/account_password/";
        if (this.state.password_type == "email"){
            //email+pic===>邮箱动态码 pwd
            const data = {
                "newpw": $('#horizontal_password2_newPassword').val(),
                "user": $('#horizontal_password_email').val(),
                "type": 3,
                "code": $('#horizontal_password_email_code_form_emailCode').val(),
            };
            axios.post(url, Qs.stringify(data),
                {headers:{'Content-Type':'application/x-www-form-urlencoded'}}
            ).then( (response)=> {
                if (response.data ==="done"){
                    this.change_modal_password('密码重置成功');
                }else{
                    this.change_modal_password('密码重置失败');
                }
            }).catch( (error) =>{
                this.change_modal_password('密码重置失败');
            })
        }else{
            //手机+网易云===>手机动态码 pwd
            const data = {
                "newpw": $('#horizontal_password2_newPassword').val(),
                "user": $('#horizontal_password_mobile').val(),
                "type": 2,
                "code": $('#horizontal_password_mobilecode').val(),
            };
            axios.post(url, Qs.stringify(data),
                {headers:{'Content-Type':'application/x-www-form-urlencoded'}}
            ).then( (response)=> {
                if (response.data ==="done"){
                    this.change_modal_password('密码重置成功');
                }else{
                    this.change_modal_password('密码重置失败');
                }
            }).catch( (error) =>{
                this.change_modal_password('密码重置失败');
            })
        }

        //清 input的内容
        $('#horizontal_password').reset();
        $('#horizontal_password_email_code_form').reset();
        $('#horizontal_password2').reset();
    };

    handleCancelRegisterResult =() => {
        this.setState({
            register_result_modal:false
        });
    }

    handleCancelMessage =() => {
        this.setState({
            mobile_code_send_modal:false
        });
    }

    handleCancelLoginResult =() => {
        this.setState({
            login_result_modal:false
        });
    }

    handleCancelPasswordResult =() => {
        this.setState({
            password_result_modal:false
        });
    }

    handleOkRegisterResult =() => {
        this.setState({
            register_result_modal:false
        });
    }

    handleCancelModal  =() => {
        this.setState({
            register_modal:false
        });
    }

    handleCancelLoginModal  =() => {
        this.setState({
            login_modal:false
        });
    }

    handleCancelPasswordModal  =() => {
        this.setState({
            password_modal_init:false
        });
    }

    handleCancelPasswordModal2  =() => {
        this.setState({
            password_modal_end:false
        });
    }

    handleCancelPasswordEmailCodeModal =() => {
        this.setState({
            password_email_code_modal:false
        });
    }

    handleCancelRegisterMobileCodeModal =() => {
        this.setState({
            register_mobile_code_modal:false
        });
    }

    handleOkModal =() => {
        this.setState({
            register_modal:false
        });
    }

    email_password_click = () =>{
        $('#horizontal_password').css('top','145px');
        this.setState({
            password_type:'email',
            email_par_display:'',
            mobile_par_display:'none',
            pwd_modal_style:'web_password_modal',
        })
    }

    mobile_password_click = () =>{
        $('#horizontal_password').css('top','60px');
        //所有关于邮箱的内容全部 不显示
        this.setState({
            password_type:'mobile',
            email_par_display:'none',
            mobile_par_display:'',
            pwd_modal_style:'web_password_modal_big',
            email_par2_display:'none',
        });
    }

    show_next_email_code = () =>{
        this.pwd_email_code_send();
        this.setState({
            password_modal_init:false,
            password_modal_end:false,
            password_type:'email',
            password_email_code_modal:true,
            pwd_email:$('#horizontal_password_email').val(),
        });
    }

    show_register_mobile_code_modal = () =>{
        this.setState({
            register_mobile_code_modal:true,
            register_mobile:$('#horizontal_register_mobile').val(),
            register_modal:false,
        });
    }

    show_pwd_end_step = () =>{
        this.setState({
            password_modal_end:true,
        });
        $('#horizontal_password2_newPassword').val('');//清空
        $('#horizontal_password2_newPasswordSure').val('');
    }

    //接口返回的意义: 注册验证时 返回不是 err 是ok的.说明数据库中没有相关记录
    callback_checkUnique = (callback,value,msg) => {
        axios.get("/api/checkUnique?userData="+value,)
        .then(res => {
            if (res.data != 'err') {
                callback();  //在这里也要写个callback
            } else {
                callback(msg);
            }
        }).catch(err =>{
            callback('http请求错误');
        })
    }

    //接口返回的意义:修改密码时 返回 err 是ok的.证明在数据库中有相关记录
    callback_checkUnique_ok = (callback,value,msg) => {
        axios.get("/api/checkUnique?userData="+value,)
        .then(res => {
            if (res.data == 'err') {
                callback();
            } else {
                callback(msg);
            }
        }).catch(err =>{
            callback('http请求错误');
        })
    }

    //验证 邮箱 动态码是否ok
    callback_email_code_ok = (callback,value,msg) => {
        axios.get("/checkImageCode?validateNum="+value,)
        .then(res => {
            if (res.data == 'err') {
                callback();
            } else {
                callback(msg);
            }
        }).catch(err =>{
            callback('http请求错误');
        })
    }

    //接收到父组件的信息,重刷新
    setLoginUserMsg = (msg)=>{
        if (msg === "open_register"){
            this.showRegisterModal();
        }else if (msg === "open_login"){
            this.init_is_login('open_login_modal');
        } else if (msg === "open_password"){
            // window.location.href = 'http://www.xrender.com/findPassword.htm';
            window.location.href = 'https://certify.xrender.com/account/reset';
        }
    }

    render() {
        // 自定义的验证
        //登录验证
        const validate_Input_login_username = (rule, value, callback)=>{
            this.callback_checkUnique_ok(callback,value,'* 账号不存在')
        }

        //注册验证
        const validate_Input_register_mobile = (rule, value, callback)=>{
            this.callback_checkUnique(callback,value,'* 手机号码已存在')
        }

        const validate_Input_register_username = (rule, value, callback)=>{
            this.callback_checkUnique(callback,value,'* 该账号已被注册')
        }

        //改密码验证
        const validate_Pwd_email = (rule, value, callback)=>{
            this.callback_checkUnique_ok(callback,value,'* 邮箱未注册')
        }

        const validate_Pwd_mobile = (rule, value, callback)=>{
            this.callback_checkUnique_ok(callback,value,'* 手机号未注册')
        }

        /*
        const validate_email_code = (rule, value, callback)=>{
            this.callback_email_code_ok(callback,value,'* 邮箱验证码错误')
        }
        */

        return(
            <>
                {/* 注册的结果 */}
                <Modal
                    title={null}
                    closable={false}
                    visible={ this.state.register_result_modal }
                    onCancel={this.handleCancelRegisterResult}
                    centered="true"
                    width="490px"
                    footer={null}
                    wrapClassName={'web_register_result'}
                >
                    <img id="cg_register_img" src={new_layer_img}/>
                    <p id="cg_register_result">{ this.state.register_result_msg }</p>
                </Modal>

                {/* 注册的modal合并 */}
                <Modal
                    title={null}
                    closable={false}
                    visible={ this.state.register_modal }
                    onCancel={this.handleCancelModal}
                    width="490px"
                    centered={true}
                    maskClosable={true}
                    footer={null}
                    wrapClassName={'web_register_modal'}
                >
                    <p id="register_title">欢迎注册CG Magic账号</p>
                    <Form  name="horizontal_register" layout="horizontal" size="middle" style={{ marginTop:'30px' }} onFinish={ this.state.new_api === 'new' ? this.xneo_onFinishRegister : this.onFinishRegister }>
                        <Form.Item
                            name="mobile"
                            validateTrigger='onBlur'
                            rules={
                                [{
                                    validator:validate_Input_register_mobile
                                },
                                {
                                    required: true,
                                    message: '* 手机号码必填',
                                },{
                                    len:11,
                                    message: '* 手机号码仅支持11位大陆号码',
                                },{
                                    pattern: new RegExp(/^((13[0-9])|(17[0-1,6-8])|(15[^4,\\D])|(18[0-9]))\d{8}$/, "g"),
                                    message: '* 请输入正确手机号码',
                                }]
                            }
                        >
                            <Input placeholder="请输入手机号码" onChange={ this.enable_but_wyy }/>
                        </Form.Item>
                        <div id="captcha_reg"></div>
                        <Button id="register_but_to_wyy" type="primary" onClick={ this.state.new_api === 'new' ? this.xneo_wyy_v2_add_register :this.wyy_v1_add_register } disabled={ this.state.isDisabled_no } style={{display: this.state.register_but_to_wyy_display}}><span>请点击验证安全码</span></Button>
                        <Form.Item style={{ textAlign: 'center' }}>
                            <Row gutter={8}>
                                <Col span={12}>
                                    <Form.Item name="mobilecode" validateTrigger='onBlur' rules={[{ required: true, message: '* 验证码必填',}]} noStyle>
                                        <Input placeholder="请输入验证码" />
                                    </Form.Item>
                                </Col>
                                <Col span={12}>
                                    <Button  id="get_mobile_code_but" type="primary" onClick={ this.state.new_api === 'new' ? this.xneo_post_get_mobilecode : this.post_get_mobilecode } disabled={ this.state.isDisabled }>
                                        <span>{this.state.register_send_mobilecode_but_msg}</span>
                                    </Button>
                                </Col>
                            </Row>
                        </Form.Item>

                        <Form.Item
                            name="username"
                            validateTrigger='onBlur'
                            rules={[
                                {
                                    required: true,
                                    message: '* 请填写用户名',
                                },
                                {
                                    validator:validate_Input_register_username
                                },
                                {
                                    pattern: new RegExp(/^[\u4e00-\u9fa5a-zA-Z0-9]+$/, "g"),//参考 https://www.cnblogs.com/BluceLee/p/11419302.html
                                    message: '* 只允许中文、字母和数字组合',
                                },
                            ]}
                        >
                            <Input placeholder="设置用户名" />
                        </Form.Item>

                        <Form.Item
                            name="password"
                            validateTrigger='onBlur'
                            rules={[
                                {
                                    required: true,
                                    message: '* 设置你的登录密码',
                                },
                                {
                                    //特殊字符 https://www.cnblogs.com/smght/p/5888208.html
                                    // 3 种类型 （至少要包含 2种） 参考  https://blog.csdn.net/chao430/article/details/76690629
                                    pattern: new RegExp(/^(?![0-9]+$)(?![a-zA-Z]+$)(?![0-9]+$)(?![(\ )(\~)(\!)(\@)(\#)(\$)(\%)(\^)(\&)(\*)(\()(\))(\-)(\_)(\+)(\=)(\[)(\])(\{)(\})(\|)(\\)(\;)(\:)(\')(\")(\,)(\.)(\/)(\<)(\>)(\?)(\)]+$)[(\ )(\~)(\!)(\@)(\#)(\$)(\%)(\^)(\&)(\*)(\()(\))(\-)(\_)(\+)(\=)(\[)(\])(\{)(\})(\|)(\\)(\;)(\:)(\')(\")(\,)(\.)(\/)(\<)(\>)(\?)(\)a-zA-Z0-9]{6,16}$/, "g"),
                                    message:'* 请使用字母、数字和符号两种及以上的组合，6-16字符)'
                                }
                            ]}
                            hasFeedback
                        >
                            <Input type="password" placeholder="设置你的登录密码"/>
                        </Form.Item>
                        <p id='register_fail_msg_tip' style={{ opacity:this.state.register_fail_msg_opacity }}>{this.state.register_fail_msg}</p>
                        <Form.Item shouldUpdate>
                            {() => (
                                <Button type="primary" htmlType="submit" id="register_modal_code"><span>注册</span></Button>
                            )}
                        </Form.Item>
                    </Form>

                    <div id="register_other">
                        <span id="register_other_title">已有CG Magic账号？</span><span id="register_login_link" onClick={()=>this.showLoginModal()}> 快捷登录></span>
                    </div>
                </Modal>

                {/* 登录结果 */}
                <Modal
                    title={null}
                    closable={false}
                    visible={ this.state.login_result_modal }
                    onCancel={this.handleCancelLoginResult}
                    width="490px"
                    centered={true}
                    maskClosable={true}
                    footer={null}
                    wrapClassName={'web_login_result'}
                >
                    <img id="cg_login_img" src={new_layer_img}/>
                    <p id="cg_login_result">{ this.state.login_result_msg }</p>
                </Modal>

                {/* 登录Modal */}
                <Modal
                    title={null}
                    closable={false}
                    visible={ this.state.login_modal }
                    onCancel={this.handleCancelLoginModal}
                    width="490px"
                    centered={true}
                    maskClosable={true}
                    footer={null}
                    wrapClassName={'web_login_modal'}
                >
                    <p id="login_title">账户密码登录</p>
                    <Form  name="horizontal_login" layout="horizontal" onFinish={ this.state.new_api === 'new' ? this.xneo_onFinishLogin : this.onFinishLogin }  size="middle" style={{ marginTop:'50px' }} encType="application/x-www-form-urlencoded">
                        <Form.Item
                            name="username"
                            validateTrigger='onBlur'
                            rules={[
                                {
                                    required: true,
                                    message: '* 请输入账号/用户名/手机号码',
                                },
                                {/*
                                 老渲云有验证 账号是否存在的接口;
                                 而新架构中是没有的;
                                 so,省略掉
                                {
                                    validator:validate_Input_login_username
                                },
                                */}
                            ]}
                        >
                            <Input placeholder="请输入账号/用户名/手机号码" prefix={<UserOutlined />}/>
                        </Form.Item>

                        <Form.Item
                            name="password"
                            validateTrigger='onBlur'
                            rules={[
                                {
                                    required: true,
                                    message: '* 请输入登录密码',
                                },
                                {
                                    min:6,
                                    message:'* 密码(不少于6位数)'
                                }
                            ]}
                            hasFeedback
                        >
                            <Input type="password" placeholder="请输入登录密码,注意区分大小写" prefix={<LockOutlined />} onChange={ this.input_login_pwd }/>
                        </Form.Item>
                        <p id='login_fail_msg_tip' style={{ opacity:this.state.login_pwd_msg_opacity }}>{this.state.login_pwd_msg}</p>
                        <Form.Item >
                            <Button type="primary" htmlType="submit" id="login_but"><span>登录</span></Button>
                        </Form.Item>
                    </Form>

                    <div id="login_other">
                        {/*
                        <span id="login_password_link" onClick={this.showPasswordModal}>忘记密码</span>
                        */}
                        {/*
                        <a  href="http://www.xrender.com/findPassword.htm" target="_blank"><span id="login_password_link">忘记密码</span></a>
                        */}
                        <a  href="https://certify.xrender.com/account/reset" target="_blank"><span id="login_password_link">忘记密码</span></a>

                        {/*
                        <span id="login_register_link" onClick={this.showRegisterModal }>免费注册</span>
                        */}
                        <a href="https://www.xrender.com/v23/register?c=MjoxMjAwMDAwMDcyMDY0Y2NjMDE3MjA2NTAxMGY4NTE5ZQ" target="_blank"><span id="login_register_link">免费注册</span></a>
                    </div>
                </Modal>

                {/* 密码重置的结果 */}
                <Modal
                    title={null}
                    closable={false}
                    visible={ this.state.password_result_modal }
                    onCancel={this.handleCancelPasswordResult}
                    centered="true"
                    width="490px"
                    footer={null}
                    wrapClassName={'web_password_result'}
                >
                    <img id="cg_password_img" src={new_layer_img}/>
                    <p id="cg_password_result">{ this.state.password_result_msg }</p>
                </Modal>


                {/* 密码重置 的 初始 init Modal */}
                <Modal
                    title={null}
                    closable={false}
                    visible={ this.state.password_modal_init }
                    onCancel={this.handleCancelPasswordModal}
                    width="490px"
                    centered={true}
                    maskClosable={true}
                    footer={null}
                    wrapClassName={ this.state.pwd_modal_style }
                >
                    <p id="by_email_password" onClick={ this.email_password_click }>通过邮箱找回密码</p>
                    <p id="by_mobile_password" onClick={ this.mobile_password_click }>通过手机找回密码</p>
                    <div id='xy_img_father' style={{ display: this.state.email_par_display }}><img  id="xy_img"  alt=""/></div>
                    <div id="captcha_pwd" className="fontClass_test" style={{ display: this.state.mobile_par_display }}></div>
                    <Button type="primary" id="pwd_mobile_code_but" onClick={ this.wyy_v1_add_pwd } style={{ display: this.state.mobile_par_display }} disabled={ this.state.password_isDisabled_no }><span>请点击验证安全码</span></Button>
                    <Form  name="horizontal_password" layout="horizontal"  size="middle"  >
                        {/* 邮箱找回密码 */}
                        <Form.Item
                            name="email"
                            validateTrigger='onBlur'
                            rules={[
                                {
                                    required: true,
                                    message: '* 请输入邮箱地址',
                                },
                                {
                                    validator:validate_Pwd_email
                                }
                            ]}
                            style={{ display: this.state.email_par_display }}
                        >
                            <Input type="email" placeholder="请输入邮箱地址" />
                        </Form.Item>

                         <Form.Item style={{ display: this.state.email_par2_display  }}>
                             <Row gutter={8}>
                                 <Col span={12}>
                                     <Form.Item name="emailcode" validateTrigger='onBlur' rules={[{ required: false }]} noStyle>
                                         <Input placeholder="邮箱验证码" />
                                     </Form.Item>
                                 </Col>
                                 <Col span={12}>
                                     <Button type="primary" onClick={ this.setpwd_post_get_emailcode } disabled={ this.state.password_email_isDisabled }>获取邮箱验证码</Button>
                                </Col>
                             </Row>
                         </Form.Item>

                        {/* 手机号找回密码  第1页的内容*/}
                        <Form.Item
                            name="mobile"
                            validateTrigger='onBlur'
                            rules={[
                                {
                                    required: false,
                                    message: '* 请输入手机号码',
                                    len:11,
                                    pattern: new RegExp(/^[1-9]\d*$/, "g"),
                                },
                                {
                                    validator:validate_Pwd_mobile
                                }
                            ]}
                            style={{ display: this.state.mobile_par_display }}
                        >
                            <Input placeholder="请输入手机号码" onChange={ this.password_enable_but_mobile }/>
                        </Form.Item>

                        {/* 手机改密码的验证wyv1. */}
                        <div id="captcha_pwd"></div>

                        <Button type="primary" onClick={ this.wyy_v1_add_pwd } id="pwd_mobile_code_but" style={{ display: this.state.pwd_but_to_wyy_display }} disabled={ this.state.password_isDisabled_no }>
                            <span>请点击验证安全码</span>
                        </Button>

                        <Form.Item style={{display: this.state.mobile_par_display }}>
                            <Row gutter={8}>
                                <Col span={12}>
                                    <Form.Item name="mobilecode" validateTrigger='onBlur' rules={[{ required: false }]} noStyle>
                                        <Input placeholder="请输入短信验证码" />
                                    </Form.Item>
                                </Col>
                                <Col span={12}>
                                    <Button id="password_get_mobile_code_but" type="primary" onClick={ this.setpwd_post_get_mobilecode } disabled={ this.state.password_isDisabled }>获取手机验证码</Button>
                                </Col>
                            </Row>
                        </Form.Item>

                        {/* 邮箱验证时需要 老渲云图片的获取 */}
                        <Form.Item
                            name="pic_code"
                            validateTrigger='onBlur'
                            rules={[
                                { required: false },
                            ]}
                            style={{ display: this.state.email_par_display }}
                        >
                            <Input placeholder="请输入验证码，不区分大小写" />
                         </Form.Item>

                        <Form.Item style={{ display: this.state.email_par_display }}>
                            <Button type="primary" onClick={ this.show_next_email_code } id="email_next_step">
                                <span>发送验证码至邮箱</span>
                            </Button>
                        </Form.Item>

                        <Form.Item style={{ display: this.state.mobile_par_display }}>
                            {/* 邮箱改密码 */}
                            <Button type="primary" onClick={ this.show_pwd_end_step} id="next_step">
                                <span>下一步</span>
                            </Button>
                        </Form.Item>
                    </Form>
                </Modal>

                {/* 邮箱输入动态码modal */}
                <Modal
                    title={null}
                    closable={false}
                    visible={ this.state.password_email_code_modal }//默认隐藏
                    onCancel={this.handleCancelPasswordEmailCodeModal}
                    width="490px"
                    centered={true}
                    maskClosable={true}
                    footer={null}
                    wrapClassName={'web_password_modal2'}
                >
                    <br />
                    <br />
                    <br />
                    <p id="password_email_code1">验证码已发送至您的登录邮箱：{this.state.pwd_email}</p>
                    <p ></p>
                    <p id="password_email_code2">请尽快登录邮箱查看验证码，</p>
                    <p id="password_email_code2">并在30分钟内将验证码输入在下方文本框中</p>
                    <Form  name="horizontal_password_email_code_form" layout="horizontal" onFinish={ this.show_pwd_end_step } size="middle" >
                        <Form.Item
                            name="emailCode"
                            validateTrigger='onBlur'
                            rules={[
                                {
                                    required: true,
                                    message: '* 请输入邮箱动态码',
                                },
                                {/*
                                {
                                    validator:validate_email_code
                                },
                                */}
                            ]}
                        >
                            <Input placeholder="请输入邮箱动态码"/>
                        </Form.Item>

                        <Form.Item>
                            <Button type="primary" htmlType="submit" id="password_but_init">
                                <span>确定</span>
                            </Button>
                        </Form.Item>
                    </Form>
                </Modal>


                {/* 重置密码的end modal 即输入新pwd 的 Model */}
                <Modal
                    title={null}
                    closable={false}// 不显示右上角的关闭按钮
                    visible={ this.state.password_modal_end }
                    onCancel={this.handleCancelPasswordModal2}
                    width="490px"
                    centered={true}
                    maskClosable={true}
                    footer={null}
                    wrapClassName={'web_password_modal2'}
                >
                    <p id="password2_title">设置新密码</p>
                    <p id="password2_title_small">设置后，您可用新密码登录CG Magic</p>
                    <Form  name="horizontal_password2" layout="horizontal" onFinish={ this.onFinishPasswordSet } size="middle" >
                        <Form.Item
                            name="newPassword"
                            validateTrigger='onBlur'
                            rules={[
                                {
                                    required: true,
                                    message: '* 请输入密码',
                                },
                                {
                                    min:6,
                                    message:'* 新密码(不少于6位数)'
                                }
                            ]}
                            hasFeedback
                        >
                            <Input type="password" placeholder="请输入新密码" prefix={<LockOutlined />}/>
                        </Form.Item>

                        <Form.Item
                            name="newPasswordSure"
                            validateTrigger='onBlur'
                            rules={[
                                {
                                    required: true,
                                    message: '* 请输入新密码',
                                },
                                ({ getFieldValue })=>({
                                    validator(rule,value){
                                       if(!value || getFieldValue('newPassword') === value){
                                           return Promise.resolve()
                                       }
                                       return Promise.reject('* 密码前后不一致')
                                    }
                                }),
                            ]}
                            hasFeedback
                        >
                            <Input type="password" placeholder="请确认密码" prefix={<LockOutlined />}/>
                        </Form.Item>

                        <Form.Item>
                            <Button type="primary" htmlType="submit" id="password_but">
                                <span>确定</span>
                            </Button>
                        </Form.Item>
                    </Form>
                </Modal>

                {/* 公共导航栏 */}
                <div id="div_fixed">
                    <img id="img_logo" src={img_logo} alt=""/>
                    <div id="header_right">
                        <a id="to_home" className='title_bottom_header' href="/" >首页</a>
                        <a className='title_bottom_header'  href="/#Function">功能介绍</a>
                        <a className='title_bottom_header'  href="/#Dynamic">产品动态</a>
                        <a className='title_bottom_header'  href="http://doc.maxplugin.com/" target="_blank">帮助中心</a>
                        <a className='title_bottom_header' href="http://www.xrender.com/?utm_source=CG%20Magic%20App&utm_medium=referral" target="_blank">免费渲</a>
                        <a className='title_bottom_header' href="mold">免费云转模（版本转换）</a>

                        <Button id="but_login" onClick={()=>this.showLoginModal()}  style={{display: this.state.login_but_display }}><p>登录</p></Button>
                        {/*
                        <Button id="but_register" onClick={ this.showRegisterModal } style={{display: this.state.register_but_display }}><p>注册</p></Button>
                        */}
                        <Button id="but_register" style={{textAlign: "center",display: this.state.register_but_display}}>
                            <a href="https://www.xrender.com/v23/register?c=MjoxMjAwMDAwMDcyMDY0Y2NjMDE3MjA2NTAxMGY4NTE5ZQ" target="_blank"><span style={{color: "#1bd17c",fontSize: "16px"}}>注册</span></a>
                        </Button>

                            <span id="login_account" style={{display: this.state.login_account_display }}> {this.state.login_account} </span>
                        <Button id="but_logout" onClick={ this.onFinishLogout } style={{ display: this.state.logout_but_display }}><p>登出</p></Button>
                    </div>
                </div>
            </>
        )
    }
}


export default HomeHead;

